export function formatDecimalSeparator(
  value: string,
  separator: ',' | '.' = '.',
  showThousandSeparator = false
): string {
  if (!value) return value;

  const thousandSeparator = separator === '.' ? ',' : '.';
  const [integerPart, decimalPart] = value.split('.');

  const formattedInteger = showThousandSeparator
    ? integerPart.replaceAll(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
    : integerPart;

  return decimalPart !== undefined ? `${formattedInteger}${separator}${decimalPart}` : formattedInteger;
}

export function parseDecimalSeparator(value: string, separator: ',' | '.' = '.'): string {
  if (!value) return value;

  const thousandSeparator = separator === '.' ? ',' : '.';

  // Special case: an input like "1,234" or "1,234,567" — a number formatted with only
  // thousand separators and no decimal part. We must handle this first, because the
  // general rule below would otherwise mistake the lone "," for a decimal point and
  // turn "1,234" into "1.234".
  const onlyContainsThousandSeparators = !value.includes(separator);
  const matchesThousandGrouping =
    thousandSeparator === ',' ? /^\d{1,3}(,\d{3})+$/.test(value) : /^\d{1,3}(\.\d{3})+$/.test(value);
  if (onlyContainsThousandSeparators && matchesThousandGrouping) {
    return value.replaceAll(thousandSeparator, '');
  }

  // General rule: the LAST "," or "." in the input is the decimal separator.
  // Anything before it is the integer part, where every "," or "." is a thousand separator.
  const decimalIndex = Math.max(value.lastIndexOf('.'), value.lastIndexOf(','));
  if (decimalIndex === -1) return value;

  const integerPart = value.slice(0, decimalIndex).replaceAll('.', '').replaceAll(',', '');
  const decimalPart = value.slice(decimalIndex + 1);
  return `${integerPart}.${decimalPart}`;
}